import {
  ConfigurationValues as ConfigurationsType,
  isOptionValidForSystem,
} from '@cutr/constants/windows/windows';
import { CONFIGURATIONS_OPTIONS } from '@cutr/constants/windows/windows-configurations.ts';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';

import i18n from '@/i18n';
import { Label } from '@/windows/primitives/Label';
import { Radio } from '@/windows/primitives/Radio';
import { RadioGroup } from '@/windows/primitives/RadioGroup';

import { ConfigurationDisplay } from '../Configurations';
import { useConfigurations, useResolvedSystem } from '../ConfigurationsContext';
import { ConfigurationComponent } from '.';

const ThicknessConfigurationInput = () => {
  const { configurations, dispatch } = useConfigurations();
  const system = useResolvedSystem();
  const { t } = useTranslation();
  const labelId = useId();
  const inputId = useId();

  const options = CONFIGURATIONS_OPTIONS.thickness.options.filter((option) =>
    isOptionValidForSystem(option, system)
  );

  return (
    <>
      <Label id={labelId} htmlFor={inputId}>
        {t('windows.configurations.thickness.label')}
      </Label>
      <RadioGroup
        aria-labelledby={labelId}
        id={inputId}
        orientation="horizontal"
        value={configurations.thickness?.value?.toString()}
        onChange={(selected) => {
          const value = options.find(
            (option) => option.value === parseInt(selected, 10)
          )!;
          dispatch({ type: 'SET_THICKNESS', value });
        }}
      >
        <span style={{ height: '38px', display: 'block' }} aria-hidden="true" />
        {options.map((option) => (
          <Radio key={option.value} value={`${option.value}`}>
            <ConfigurationDisplay configurationKey="thickness" value={option} />
          </Radio>
        ))}
      </RadioGroup>
    </>
  );
};

const config: ConfigurationComponent<'thickness'> = {
  key: 'thickness',
  input: <ThicknessConfigurationInput />,
  display: (value: ConfigurationsType['thickness']) => (
    <span>
      {i18n.t('windows.configurations.thickness.value', {
        value: value.value,
      })}
    </span>
  ),
};

export default config;
